import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import LazySize from "./LazySize";

LazyImageWith9Ratio11.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.object,
};

function LazyImageWith9Ratio11({ src, alt, children, onClick, sx }) {
  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
        paddingTop: "calc(11 / 9 * 100%)",
        ...(onClick && { cursor: "pointer" }),
      }}
      onClick={onClick}
    >
      <LazySize
        alt={alt}
        src={src}
        hidePlaceholder={true}
        sx={{
          borderRadius: { xs: "4px", md: "8px" },
          ...sx,
        }}
      />
      {children}
    </Box>
  );
}

export default LazyImageWith9Ratio11;
